import { useMutation, useQueryClient } from '@tanstack/react-query';
import { del } from '@truefit/http-utils';
import useCurrentGameId from '@/shared/hooks/useCurrentGameId';

interface DeleteCustomEventParams {
  eventId: number;
  hard?: boolean; // Optional hard delete flag
}

const useDeleteCustomEventMutation = () => {
  const queryClient = useQueryClient();
  const gameId = useCurrentGameId();

  return useMutation({
    mutationFn: async ({ eventId, hard = false }: DeleteCustomEventParams) => {
      const url = `/v1.0/games/${gameId}/custom-events/${eventId}${hard ? '?hard=true' : ''}`;
      await del(url);
    },
    onSuccess: () => {
      // Invalidate queries to refresh the events list
      queryClient.invalidateQueries({
        queryKey: ['Games', gameId, 'CustomEvents']
      });
      queryClient.invalidateQueries({
        queryKey: ['Games', gameId, 'PlayByPlay']
      });
    },
  });
};

export default useDeleteCustomEventMutation;
